import React from 'react';
import { Box, styled, Typography } from '@mui/material';
import Modal from './Modal';
import Button from 'new/components/Button/Button';

const CardModalTitle = styled(Typography)(({ theme }) => ({
  fontSize: theme.typography.pxToRem(28),
  fontWeight: 700,
  textAlign: 'center',
  color: theme.palette.primary.dark,
}));

const CardModalText = styled(Typography)(({ theme }) => ({
  marginTop: theme.spacing(2),
  color: theme.palette.grey[600],
  textAlign: 'center',
}));

const StyledModal = styled(Modal)({
  '.modalContent': {
    width: 500,
  },
});

type Props = {
  modalTitle: string;
  modalText: string;
  confirmButtonLabel: string;
  open?: boolean;
  isLoading?: boolean;
  onDelete: () => void;
  onClose: () => void;
};

const ConfirmModal: React.FC<Props> = ({
  modalTitle,
  modalText,
  confirmButtonLabel,
  open = false,
  isLoading,
  onClose,
  onDelete,
}) => {
  return (
    <StyledModal open={open} onClose={onClose}>
      <CardModalTitle>{modalTitle}</CardModalTitle>
      <CardModalText>{modalText}</CardModalText>
      <Box
        sx={{ display: 'flex', gap: 2, marginTop: 4, justifyContent: 'center' }}
        onClick={(e) => {
          e.stopPropagation();
        }}
      >
        <Button color="secondary" variant="outlined" onClick={onClose}>
          CANCEL
        </Button>
        <Button
          color="primary"
          variant="contained"
          isLoading={isLoading}
          onClick={() => {
            onDelete();
          }}
        >
          {confirmButtonLabel}
        </Button>
      </Box>
    </StyledModal>
  );
};

export default ConfirmModal;
